// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7DEeS","badges":"styles_badges__3Ee8D"};